module.exports = __webpack_public_path__ + "img/interface_bg.393ee1a1.png";